<template>
    <div class="life_index_wrap">
        <div class="top_scroll">
            <div
                :class="categoryid ==  '' ? 'scroll_item active' : 'scroll_item'"
                @click="selectCategory('')"
            >全部</div>
            <div
                :class="categoryid ==  item.id ? 'scroll_item active' : 'scroll_item'"
                v-for="(item, index) in categoryList"
                :key="index"
                @click="selectCategory(item.id)"
            >{{item.name}}</div>
        </div>
        <div v-show="!categoryid" class="brand_list fr fw">
            <div
                v-for="(item, index) in brandList"
                :key="index"
                class="brand_item fc ac jsb"
                @click="switchBrand(item.categoryId, item.id)"
            >
                <img :src="imgBaseUrl + item.logo" alt />
                <span>{{item.name}}</span>
            </div>
        </div>
        <div v-show="categoryid" class="brand_scroll" id="brand_scroll">
            <div class="brand_item_wrap" @click="selectBrand('')">
                <div
                    :class="goodsBrandId == '' ? 'brand_item fc ac jsb selected' : 'brand_item fc ac jsb'"
                >
                    <img class="all_icon" src="../../../static/imgs/mall/all.png" alt />
                    <span>全部</span>
                </div>
            </div>
            <div
                v-for="(item, index) in brandList"
                :key="index"
                class="brand_item_wrap"
                @click="selectBrand(item.id)"
            >
                <div
                    :class="goodsBrandId == item.id ? 'brand_item fc ac jsb selected' : 'brand_item fc ac jsb'"
                >
                    <img class="brand_logo" :src="imgBaseUrl + item.logo" alt />
                    <span>{{item.name}}</span>
                </div>
            </div>
        </div>
        <div
            class="page_list fc ac"
            v-if="productList.length"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="0"
        >
            <h3>为您推荐</h3>
            <div
                class="product_item fr ac"
                v-for="(item, index) in productList"
                :key="index"
                @click="viewProduct(item.id)"
            >
                <img class="product_img" :src="imgBaseUrl + item.logo" alt />
                <div class="info_box fc jsb">
                    <h4>{{item.title}}</h4>
                    <div class="fr ac jsb">
                        <div class="fc">
                            <span class="ori_price">官方价：￥{{item.faceprice / 100}}</span>
                            <span class="price">￥{{item.saleprice / 100}}</span>
                        </div>
                        <button v-if="item.canbuy" class="btn">立即购买</button>
                        <button v-else class="sold_out">已售罄</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Indicator } from "mint-ui";
export default {
    data() {
        return {
            categoryList: [],
            brandList: [],
            productList: [],
            categoryid: "",
            goodsBrandId: "",
            pageNo: 1,
            imgBaseUrl: this.$global.imgBaseUrl,
            screenWidth: document.body.clientWidth,
        };
    },
    components: {},
    created() {
        this.getCategoryList();
        this.getBrandList();
        this.getProductList();
    },
    watch: {},
    methods: {
        getCategoryList() {
            Indicator.open("加载中...");
            this.$post({
                method: "goods.category.list",
            }).then((res) => {
                Indicator.close();
                if (res.success) {
                    this.categoryList = res.data;
                }
            });
        },
        getBrandList() {
            Indicator.open("加载中...");
            this.$post({
                method: "goods.brand.list",
                categoryId: this.categoryid,
            }).then((res) => {
                Indicator.close();
                if (res.success) {
                    this.brandList = res.data;
                    if (this.categoryid && this.goodsBrandId) {
                        for (let i in res.data) {
                            if (res.data[i].id == this.goodsBrandId) {
                                this.scrollToIdx(i);
                            }
                        }
                    }
                }
            });
        },
        getProductList() {
            Indicator.open("加载中...");
            this.$post({
                method: "goods.list",
                pageSize: 10,
                pageNo: this.pageNo,
                categoryid: this.categoryid,
                goodsBrandId: this.goodsBrandId,
            }).then((res) => {
                Indicator.close();
                if (res.success) {
                    this.productList = this.productList.concat(
                        res.data.goodsList
                    );
                }
            });
        },
        selectCategory(id) {
            this.categoryid = id;
            this.productList = [];
            this.pageNo = 1;
            this.goodsBrandId = "";
            this.getBrandList();
            this.getProductList();
        },
        selectBrand(id) {
            this.goodsBrandId = id;
            this.productList = [];
            this.pageNo = 1;
            this.getProductList();
        },
        loadMore() {
            if (this.$route.path == "/lifeIndex") {
                this.pageNo++;
                this.getProductList();
            }
        },
        switchBrand(ctegoryId, brandId) {
            this.categoryid = ctegoryId;
            this.goodsBrandId = brandId;
            this.productList = [];
            this.pageNo = 1;
            this.getBrandList();
            this.getProductList();
        },
        scrollToIdx(idx) {
            this.$nextTick(() => {
                setTimeout(() => {
                    let brandScroll = document.getElementById("brand_scroll");
                    brandScroll.scrollLeft =
                        (148 * idx * this.screenWidth) / 750;
                }, 10);
            });
        },
        viewProduct(id) {
            this.$router.push({
                path: "/lifeCouponDetail",
                query: { gid: id },
            });
        },
    },
};
</script>
<style lang="scss">
.life_index_wrap {
    width: 100%;
    .top_scroll {
        position: fixed;
        top: 0;
        width: 100%;
        height: 80px;
        background: #fc0;
        z-index: 5;
        overflow-x: scroll;
        white-space: nowrap;
        font-size: 28px;
        .scroll_item {
            display: inline-block;
            width: 140px;
            height: 80px;
            line-height: 80px;
            text-align: center;
            position: relative;
        }
        .active {
            font-size: 32px;
        }
        .active::after {
            content: "";
            width: 40px;
            height: 4px;
            position: absolute;
            bottom: 0;
            right: calc(50% - 20px);
            background: #222;
            border-radius: 2px;
        }
    }
    .top_scroll::-webkit-scrollbar {
        display: none;
    }
    .brand_list {
        margin-top: 80px;
        background: #fff;
        padding-bottom: 20px;
        .brand_item {
            width: 148px;
            height: 140px;
            margin-top: 30px;
            font-size: 28px;
            img {
                width: 88px;
                height: 88px;
                border-radius: 50%;
                border: 1px solid #dededf; /* no */
                box-sizing: border-box;
            }
        }
    }
    .brand_scroll {
        // width: 100%;
        height: 200px;
        white-space: nowrap;
        overflow-x: scroll;
        background: #fff;
        margin-top: 80px;
        .brand_item_wrap {
            display: inline-block;
            width: 148px;
            height: 140px;
            margin: 30px 0;
            .brand_item {
                height: 140px;
                img {
                    width: 88px;
                    height: 88px;
                    border-radius: 50%;
                    border: 1px solid #dededf; /* no */
                    box-sizing: border-box;
                }
            }
            .selected {
                .brand_logo,
                .all_icon {
                    border: 4px solid #fc0;
                }
                span {
                    font-size: 30px;
                }
            }
        }
    }
    .brand_scroll::-webkit-scrollbar {
        display: none;
    }
    .page_list {
        h3 {
            width: 100%;
            padding: 0 35px;
            box-sizing: border-box;
            font-size: 32px;
            height: 90px;
            line-height: 90px;
        }
        .product_item {
            width: 680px;
            height: 260px;
            background: #fff;
            padding: 40px 28px 40px 40px;
            box-sizing: border-box;
            border-radius: 10px;
            margin-bottom: 30px;
            .product_img {
                width: 180px;
                height: 180px;
                margin-right: 25px;
            }
            .info_box {
                width: calc(100% - 205px);
                height: 180px;
                h4 {
                    font-size: 26px;
                }
                .ori_price {
                    font-size: 24px;
                    color: #999;
                    margin-bottom: 10px;
                }
                .price {
                    font-size: 28px;
                    color: #e42f46;
                    margin-right: 15px;
                }
                .btn {
                    width: 160px;
                    height: 60px;
                    line-height: 60px;
                    font-size: 28px;
                    background: #fc0;
                    border-radius: 10px;
                    padding: 0;
                }
                .sold_out {
                    width: 160px;
                    height: 60px;
                    line-height: 60px;
                    font-size: 28px;
                    background: #eee;
                    color: #999;
                    border-radius: 10px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/life/lifeIndex.vue